<div class="modal__main">
    <div class="main__rightpart" *ngIf="!breakpoints.extraSmall">
        <div class="main__rightpart_sory-gray-block">
            <div class="flex-container">
                <div class="text-cont">
                    <span id="oops">Oops!</span>
                    <span id="itus">It’s not you — it’s us.</span>
                </div>
                <div class="leftpart__image leftpart__image_big">
                    <img id="imgg" src="../../../assets/images/error-screen.svg')" alt="" loading="lazy" />
                </div>
            </div>
            <div (click)="closeErrorEvent()" id="closeBtn" class="btn btn-size_normal btn-primary font-lg-medium-big m-x-auto">
                Please Try Again
            </div>
        </div>
    </div>

    <div class="main__rightpart" *ngIf="breakpoints.extraSmall">
        <div id="rHeader" class="rightpart__header rightpart__header_bg-orange header-smaller"></div>
        <div class="leftpart__image leftpart__image_big">
            <img id="imgg" src="../../../assets/images/error-screen-mobile.svg')" alt="" loading="lazy" />
        </div>
        <div class="text-cont">
            <span id="oops">Oops!</span>
            <span id="itus">It’s not you — it’s us.</span>
        </div>
    </div>
</div>